/**
 * @author xujw 2018-8-27 16:08:07
 * 控件资源路径动态生成
 */

/**
 * 获取控件资源路径
 * @param {String} widgetCode 控件编码
 * @param {String} relativePath 相对路径
 */
const depLibsDir = "dependencies";

function getWidgetResPath(widgetCode, pluginType, relativePath) {
    // 执行系统资源前缀
    var runtime_prefix = 'itop/common/extension/custom';
    var resurl = relativePath;
    var pathFlag = relativePath.split('/');
    var fileName = pathFlag[pathFlag.length - 1];
    /* 如果为执行系统环境则生成执行系统环境地址 */
    if (typeof window._$v3platform_runtime_env != 'undefined' && window._$v3platform_runtime_env) {
        resurl = `${runtime_prefix}/${pluginType}/${widgetCode}/${fileName}`;
    } else if (typeof GlobalVariables != 'undefined') {
        let serverUrl = GlobalVariables.getServerUrl();
        resurl = `${serverUrl}/${runtime_prefix}/${pluginType}/${widgetCode}/${fileName}`;
    } else if (typeof window._$v3platform_preview_env != 'undefined' && window._$v3platform_preview_env) {
        resurl = `${depLibsDir}/${widgetCode}/${relativePath.substring(relativePath.indexOf('/'))}`;
    }
    return resurl;
}

export default {
    getWidgetResPath
}


// WEBPACK FOOTER //
// ./src/Resource.js